module.exports = __webpack_public_path__ + "media/images/icons/filled/printer-0c5864d6d7a4953e7c525fc04d631d9d.svg";